import React from 'react';
import { FiMail } from 'react-icons/fi';

const EmailSegment = ({ email, onEmailChange, emailError, onFocus }) => {
  return (
    <div className={`sf-searchbar__segment sf-searchbar__segment--email ${emailError ? 'sf-searchbar__segment--error' : ''}`}>
      <span className="sf-searchbar__segment-icon">
        <FiMail />
      </span>
      <div className="sf-searchbar__segment-text">
        <label className="sf-searchbar__segment-label">EMAIL *</label>
        <input
          type="email"
          className="sf-searchbar__segment-value sf-searchbar__segment-input"
          placeholder="tu@email.com"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          onFocus={onFocus}
        />
      </div>
    </div>
  );
};

export default EmailSegment;
